"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RestoreStrategy = /** @class */ (function () {
    function RestoreStrategy(strategy) {
        this.strategy = strategy;
    }
    return RestoreStrategy;
}());
exports.default = RestoreStrategy;
//# sourceMappingURL=RestoreStrategy.js.map